import { confirmSignUp, resendSignUpCode, signIn } from 'aws-amplify/auth';
import { codeResponseErrorsMap } from 'constants/confirmationCodeResponse';
import { FormikHelpers } from 'formik';

import usePromiseStatus from 'hooks/usePromiseStatus';

import { AuthModal, IModalProps as Props } from 'interfaces/auth';

import { AuthModalView, useAuthModalsContext } from 'components/AuthModals';
import { ConfirmationCodeForm } from 'components/ConfirmationCodeForm/ConfirmationCodeForm';

interface IEnterCodeStepValues {
  code: string;
}

export const EnterCodeStep = ({ onModalClose, isModalOpened }: Props) => {
  const { track, isPending } = usePromiseStatus();
  const { resetFormData, setAuthModal, setModalError } = useAuthModalsContext();

  const submitHandler = async ({ code }: IEnterCodeStepValues, actions: FormikHelpers<IEnterCodeStepValues>) => {
    try {
      const signUpData = await track(confirmSignUp({ username: resetFormData.email, confirmationCode: code }));

      if (signUpData.isSignUpComplete) {
        actions.setFieldError('code', '');

        await track(signIn({ username: resetFormData.email, password: resetFormData.password }));
      }

      setModalError(null);
      onModalClose();
    } catch (error) {
      error instanceof Error && actions.setFieldError('code', codeResponseErrorsMap.get(error.name));
    }
  };

  const prevStep = () => {
    setAuthModal(AuthModal.LOGIN);
  };

  return (
    <AuthModalView isModalOpened={isModalOpened} onModalClose={onModalClose}>
      <ConfirmationCodeForm
        emailValue={resetFormData.email}
        isPending={isPending}
        backClickHandler={prevStep}
        closeClickHandler={onModalClose}
        resendCodeHandler={resendSignUpCode}
        onSubmit={submitHandler}
      />
    </AuthModalView>
  );
};
